import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import AuthenticatedRoutes from "./AuthenticatedRoutes";
import InnerRoutes from "./InnerRoutes";

const AppRoutes = () => {
  return (
    <Router basename={process.env.REACT_APP_BASENAME || "/"}>
      <Routes>
        <Route path="/app/*" element={<AuthenticatedRoutes />} />
        <Route path="/*" element={<InnerRoutes />} />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
